import { useEffect } from 'react'
import effects from 'app/effects/effects'
import { useSelector, useDispatch } from 'react-redux'
import * as R from 'ramda'
import { setAppSettings } from 'app/store/actions/appSettings.actions'
import { useIsAuthorized } from 'app/auth/authHooks'

export const useAppSettingsProvider = () => {
  const dispatch = useDispatch()
  const isAuthorized = useIsAuthorized()
  useEffect(() => {
    if (isAuthorized)
      effects.apis
        .settings()
        .then(R.compose(dispatch, setAppSettings, R.propOr([], 'data')))
  }, [dispatch, isAuthorized])
}

export const useAppSettings = () => useSelector(R.prop('appSettings'))

export const getValueByKeyOr = (defaultValue, key) =>
  R.compose(R.propOr(defaultValue, 'value'), R.find(R.propEq('key', key)))

export const getTrialPeriod = getValueByKeyOr(undefined, 'trial_period')

export const getGracePeriod = getValueByKeyOr(undefined, 'grace_period')

export const getSkipTranslation = R.compose(
  R.not,
  R.equals('0'),
  getValueByKeyOr(false, 'skip_translation'),
)

export const getSettingByKey = (key) => {
  return getValueByKeyOr(undefined, key)
}
